import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
        minHeight: 52,
        // TODO: Move this into the theme, where z-indexes are centralized.
        zIndex: 39,
        boxShadow: '0 2px 2px -2px rgba(0,0,0,0.28)',
        padding: '8px 16px',
        margin: '8px 8px 0px 8px',
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
    },

    icon: {
        marginRight: 24,
        '& svg': {
            height: 'unset',
            fontSize: 32,
            position: 'relative',
            top: 2,
        },
    },

    text: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.grow(1),
        padding: '8px 0px',
        minWidth: 200,
    },

    success: {
        border: `1px solid ${theme.palette.alert.success}`,

        '& svg': {
            color: theme.palette.alert.success,
        },
    },

    info: {
        border: `1px solid ${theme.palette.alert.info}`,

        '& svg': {
            color: theme.palette.alert.info,
        },
    },

    warning: {
        border: `1px solid ${theme.palette.alert.warning}`,

        '& svg': {
            color: theme.palette.alert.warning,
        },
    },

    error: {
        border: `1px solid ${theme.palette.alert.error}`,

        '& svg': {
            color: theme.palette.alert.error,
        },
    },
}));
